<template>
    <div class="page-container">
        <div class="page-inner page-left">
            <div class="page-box-title title1">
                <span>作文秒评记录</span>
                <template v-if="!isDelFlag">
                    <el-button style="float:right;" link @click="manageEvent">
                        <el-icon>
                            <Setting />
                        </el-icon>管理</el-button>
                </template>
                <template v-if="isDelFlag">
                    <el-button style="float:right;" link @click="delEvent">
                        <el-icon>
                            <Delete />
                        </el-icon>删除</el-button>
                    <el-button style="float:right;" link @click="cancelEvent">
                        取消</el-button>
                </template>
            </div>
            <div class="paper-tabs">
                <el-form :model="searchInfo">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="作文状态">
                                <el-select v-model="searchInfo.type" style="width: 100%" placeholder="请选择作文状态">
                                    <el-option v-for="item in compositionType" :key="item.value" :label="item.label" :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="评阅类型">
                                <el-select v-model="searchInfo.tabType" style="width: 100%" placeholder="请选择评阅类型">
                                    <el-option v-for="item in correctingType" :key="item.value" :label="item.label" :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="时间范围">
                                <el-config-provider :locale="zhCn">
                                    <el-date-picker value-format="YYYY-MM-DD" v-model="searchInfo.date" type="daterange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" />
                                </el-config-provider>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <div>
                                <el-button type="primary" color="#ef8b25" plain @click="handleCurrentChange(1)">查询</el-button>
                                <el-button type="info" plain @click="resetEvent">重置</el-button>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="history-box">
                <div class="page-inner-box empty" v-if="!tableList.length">
                    <img src="@/assets/img/empty.png" />
                    <div>暂无数据</div>
                </div>
                <template v-else>
                    <div class="history-box-item" v-for="(item,index) in tableList" :key="index">
                        <div class="history-box-item-top">
                            <div class="title1">
                                <el-checkbox v-if="isDelFlag" v-model="item.checked" style="margin-right:5px;" />{{item.artiCorrectingTitle}}</div>
                            <div class="history-box-item-tag">
                                <div :class="['tag1','correctClass'+item.correctingType]">{{correctingTypeFormat(item.correctingType)}}</div>
                                <div :class="['tag2','statusClass'+item.type]">{{statusFormat(item.type)}}</div>
                            </div>
                        </div>
                        <div class="history-box-item-inner">
                            {{item.artiCorrectingTxt}}
                        </div>
                        <div class="history-box-item-bottom">
                            <div class="history-box-item-time">{{item.updateTime}}</div>
                            <div>
                                <el-button color="#666" size="small" plain v-show="[1].includes(item.type) || !item.artiRewriteId" @click="toRewrite(item)">作文重写</el-button>
                                <el-button color="#666" size="small" plain @click="toCorrectResult(item,'correctResult')">批改结果</el-button>
                                <el-button color="#ef8b25" size="small" plain v-show="[1,2].includes(item.type)" @click="toPolish(item)">作文润色</el-button>
                                <el-button color="#ef8b25" size="small" plain v-show="[3].includes(item.type)" @click="toCorrectResult(item,'runseResult')">润色结果</el-button>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div style="text-align:center;margin-top:10px;">
                <el-config-provider :locale="zhCn" v-if="pageShow">
                    <el-pagination v-model:current-page="pageInfo.current" v-model:page-size="pageInfo.size" :total="pageInfo.total" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
                </el-config-provider>
            </div>
        </div>
        <div class="page-inner page-right">
            <div class="teaching-box">
                <div class="teaching-box-btn">
                    <el-radio-group v-model="teachingActive" fill="#fae8d4" text-color="#ef8b25" @change="teachingClick">
                        <el-radio-button label="第一版" value="artiCorrecting" :disabled="!artiCorrectingId" v-show="['correctResult'].includes(handleType)" />
                        <el-radio-button label="重写版" value="artiRewrite" :disabled="!artiRewriteId" v-show="['correctResult'].includes(handleType)" />
                        <el-radio-button label="AI润色版" value="artiPolishing" :disabled="!artiPolishingId" v-show="['correctResult','runseResult'].includes(handleType)" />
                    </el-radio-group>
                </div>
            </div>
            <div class="page-inner-box" style="max-height:300px;height:auto;">
                <div class="correctTitle">作文内容：</div>
                <div>{{artiText || '未输入作文内容'}}</div>
            </div>
            <template v-if="fileList.length">
                <div class="history-file">
                    <div class="history-file-item" v-for="(item,index) in fileList" :key="index">
                        <el-image style="width: 100%; height: 100%" :src="item" :zoom-rate="1.2" :max-scale="7" :min-scale="0.2" :preview-src-list="fileList" show-progress :initial-index="index" fit="cover" />
                    </div>
                </div>
                <div class="history-tip">
                    <span class="activeColor">*提示：</span>
                    <span>可点击上方小图放大图片查看作文上传记录</span>
                </div>
            </template>
            <template v-if="teachingActive=='artiCorrecting'">
                <div class="page-inner-box" v-if="Object.keys(artiCorrectingResultInfo).length">
                    <template v-if="artiCorrectingResultInfo.Ⅰ && artiCorrectingResultInfo.Ⅰ.length">
                        <div v-for="(item,index) in artiCorrectingResultInfo.Ⅰ" :key="'cⅠ'+index">
                            <div v-html="item"></div>
                        </div>
                    </template>
                    <template v-if="artiCorrectingResultInfo.Ⅱ && artiCorrectingResultInfo.Ⅱ.length">
                        <div v-for="(item,index) in artiCorrectingResultInfo.Ⅱ" :key="'cⅡ'+index">
                            <div v-html="item"></div>
                        </div>
                    </template>
                    <template v-if="artiCorrectingResultInfo.Ⅲ && artiCorrectingResultInfo.Ⅲ.length">
                        <div class="" v-for="(item,index) in artiCorrectingResultInfo.Ⅲ" :key="'cⅢ'+index">
                            <div v-html="item"></div>
                        </div>
                    </template>
                    <template v-if="artiCorrectingResultInfo.Ⅳ && artiCorrectingResultInfo.Ⅳ.length">
                        <div class="" v-for="(item,index) in artiCorrectingResultInfo.Ⅳ" :key="'cⅣ'+index">
                            <div v-html="item"></div>
                        </div>
                    </template>
                    <template v-if="artiCorrectingResultInfo.Ⅴ && artiCorrectingResultInfo.Ⅴ.length">
                        <div class="" v-for="(item,index) in artiCorrectingResultInfo.Ⅴ" :key="'Ⅴ'+index">
                            <div v-html="item"></div>
                        </div>
                    </template>
                    <template v-if="artiCorrectingResultInfo.Ⅵ && artiCorrectingResultInfo.Ⅵ.length">
                        <div class="" v-for="(item,index) in artiCorrectingResultInfo.Ⅵ" :key="'cⅥ'+index">
                            <div v-html="item"></div>

                            <div v-html="artiCorrectingResultInfo.Ⅶ[index]" v-if="artiCorrectingResultInfo.Ⅶ && artiCorrectingResultInfo.Ⅶ.length>=artiCorrectingResultInfo.Ⅵ.length"></div>
                            <div v-html="artiCorrectingResultInfo.Ⅷ[index]" v-if="artiCorrectingResultInfo.Ⅷ && artiCorrectingResultInfo.Ⅷ.length>=artiCorrectingResultInfo.Ⅵ.length"></div>
                        </div>
                    </template>
                </div>
                <div class="page-inner-box" v-else>
                    <div v-html="artiCorrectingInfo.artiCorrectingResult"></div>
                </div>
            </template>
            <template v-if="teachingActive=='artiRewrite'">
                <div class="page-inner-box" v-if="Object.keys(artiRewriteResultInfo).length">
                    <template v-if="artiRewriteResultInfo.Ⅰ && artiRewriteResultInfo.Ⅰ.length">
                        <div class="" v-for="(item,index) in artiRewriteResultInfo.Ⅰ" :key="'rⅠ'+index">
                            <div v-html="item"></div>
                        </div>
                    </template>
                    <template v-if="artiRewriteResultInfo.Ⅱ && artiRewriteResultInfo.Ⅱ.length">
                        <div class="" v-for="(item,index) in artiRewriteResultInfo.Ⅱ" :key="'rⅡ'+index">
                            <div v-html="item"></div>
                        </div>
                    </template>
                    <template v-if="artiRewriteResultInfo.Ⅲ && artiRewriteResultInfo.Ⅲ.length">
                        <div class="" v-for="(item,index) in artiRewriteResultInfo.Ⅲ" :key="'rⅢ'+index">
                            <div v-html="item"></div>
                        </div>
                    </template>
                    <template v-if="artiRewriteResultInfo.Ⅳ && artiRewriteResultInfo.Ⅳ.length">
                        <div class="" v-for="(item,index) in artiRewriteResultInfo.Ⅳ" :key="'rⅣ'+index">
                            <div v-html="item"></div>
                        </div>
                    </template>
                    <template v-if="artiRewriteResultInfo.Ⅴ && artiRewriteResultInfo.Ⅴ.length">
                        <div class="" v-for="(item,index) in artiRewriteResultInfo.Ⅴ" :key="'rⅤ'+index">
                            <div v-html="item"></div>
                        </div>
                    </template>
                    <template v-if="artiRewriteResultInfo.Ⅵ && artiRewriteResultInfo.Ⅵ.length">
                        <div class="" v-for="(item,index) in artiRewriteResultInfo.Ⅵ" :key="'rⅥ'+index">
                            <div v-html="item"></div>
                        </div>
                    </template>
                </div>
                <div class="page-inner-box" v-else>
                    <div v-html="artiRewriteInfo.artiRewriteResult"></div>
                </div>
            </template>
            <template v-if="teachingActive=='artiPolishing'">
                <div class="page-inner-box" v-if="Object.keys(artiPolishingResultInfo).length">
                    <div class="correctTitle">润色后的作文</div>
                    <template v-if="artiPolishingResultInfo.Ⅰ && artiPolishingResultInfo.Ⅰ.length">
                        <div class="correctTitle2" style="text-align: center;" v-for="(item,index) in artiPolishingResultInfo.Ⅰ" :key="'PⅠ'+index">
                            <div v-html="item"></div>
                        </div>
                    </template>
                    <template v-if="artiPolishingResultInfo.Ⅱ && artiPolishingResultInfo.Ⅱ.length">
                        <div class="correctTitle5" v-for="(item,index) in artiPolishingResultInfo.Ⅱ" :key="'PⅡ'+index">
                            <div v-html="item"></div>
                        </div>
                    </template>

                    <template v-if="artiPolishingResultInfo.Ⅲ && artiPolishingResultInfo.Ⅲ.length">
                        <div class="correctTitle">
                            修改思路和方法
                        </div>
                        <div style="text-indent: unset;" class="correctTitle5" v-for="(item,index) in artiPolishingResultInfo.Ⅲ" :key="'PⅢ'+index">
                            <div v-html="item"></div>
                        </div>
                    </template>
                </div>
                <div class="page-inner-box" v-else>
                    <div v-html="artiPolishingInfo.artiPulishingResult"></div>
                </div>
            </template>
            <div class="page-inner-box empty" v-if="!Object.keys(artiCorrectingResultInfo).length && !Object.keys(artiRewriteResultInfo).length && !Object.keys(artiPolishingResultInfo).length">
                <img src="@/assets/img/empty.png" />
                <div>结果将在此处展示！</div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, reactive, onMounted, computed, nextTick } from 'vue';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import { getHistory, getCorrecting, getRewrite, getPolishing, delArti } from "@/api/composition.js"
import { useRouter } from 'vue-router';
import { ElMessage } from "element-plus";
const router = useRouter()
const tabActive = ref('0')
const teachingActive = ref('artiCorrecting')
const tableList = ref([])
const artiCorrectingInfo = ref({})
const artiCorrectingResultInfo = ref({})
const artiRewriteInfo = ref({})
const artiRewriteResultInfo = ref({})
const artiPolishingInfo = ref({})
const artiPolishingResultInfo = ref({})
const artiCorrectingId = ref('')
const artiRewriteId = ref('')
const artiPolishingId = ref('')
const aiMessage = ref()
const handleType = ref('correctResult')
const searchInfo = ref({})
const romanNumerals = ["Ⅰ", "Ⅱ", "Ⅲ", "Ⅳ", "Ⅴ", "Ⅵ", "Ⅶ", "Ⅷ", "Ⅸ", "Ⅹ"];
const regex = new RegExp(`(${romanNumerals.join('|')})|([^${romanNumerals.join('')}]+)`, 'g');
const romanNumeralsArr = romanNumerals
const compositionType = [{
    label: '全部',
    value: '0'
},
{
    label: '未重写',
    value: '1'
},
{
    label: '已重写',
    value: '2'
},
{
    label: '已润色',
    value: '3'
}
]

const correctingType = [{
    label: '全部',
    value: '00'
},
{
    label: '常规评阅',
    value: '01'
}, {
    label: '教学评阅',
    value: '02'
},
{
    label: '考试评阅',
    value: '03'
}
]
const fileList = computed(() => {
    if (teachingActive.value == 'artiCorrecting') {
        return artiCorrectingId.value && artiCorrectingInfo.value.artiCorrectingFileUrlList || []
    } else if (teachingActive.value == 'artiRewrite') {
        return artiRewriteId.value && artiRewriteInfo.value.artiRewriteFileUrlList || []
    } else if (teachingActive.value == 'artiPolishing') {
        return artiPolishingId.value && artiPolishingInfo.value.artiPulishingFileUrlList || []
    }
    return []
})
const artiText = computed(() => {
    if (teachingActive.value == 'artiCorrecting') {
        return artiCorrectingId.value && artiCorrectingInfo.value.artiCorrectingTxt || ''
    } else if (teachingActive.value == 'artiRewrite') {
        return artiRewriteId.value && artiRewriteInfo.value.artiRewriteTxt || ''
    } else if (teachingActive.value == 'artiPolishing') {
        return artiPolishingId.value && artiPolishingInfo.value.artiPolishingTxt || ''
    }
    return []
})
const pageInfo = ref({
    current: 1,
    size: 10,
    total: 10
})
const pageShow = ref(true)
const isDelFlag = ref(false)
function resetEvent() {
    searchInfo.value = {}
}
function correctingTypeFormat(val) {
    switch (val) {
        case '01':
            return '常规评阅'
        case '02':
            return '教学评阅'
        case '03':
            return '考试评阅'
        default:
            return val
    }
}
function manageEvent() {
    isDelFlag.value = true
}
function tabClick(item) {
    if (tabActive.value == item.value) return
    tabActive.value = item.value;
    handleCurrentChange(1)
}
function handleSizeChange(val) {
    pageInfo.value.size = val;
    getList()
}
function handleCurrentChange(val) {
    pageInfo.value.current = val;
    pageShow.value = false;
    getList()
    nextTick(() => {
        pageShow.value = true;
    })
}
function getList(cb) {
    const params = {
        current: pageInfo.value.current,
        size: pageInfo.value.size,
        type: searchInfo.value.type || '0',
        tabType: searchInfo.value.tabType || '00',
    }
    if (searchInfo.value.date) {
        params.startDate = searchInfo.value.date[0]
        params.endDate = searchInfo.value.date[1]
    }
    pageInfo.value.total = 0;
    tableList.value = []
    getHistory(params).then((res: any) => {
        tableList.value = (res.data.records || []).map(item => {
            return {
                ...item,
                checked: false
            }
        })
        pageInfo.value.total = res.data.total || 0;
        cb && cb()
    })
}
function statusFormat(val) {
    const obj = compositionType.find(item => {
        return item.value == val
    })
    return obj.label
}
function toCorrectResult(item, type) {
    handleType.value = type
    if (type == 'runseResult') {
        artiPolishingId.value = item.artiPolishingId
        item.artiPolishingId && getPolishingInfo((res) => {
            teachingActive.value = 'artiPolishing'
            aiMessage.value = res.data.artiPulishingResult;
        })
    } else {
        artiCorrectingId.value = item.artiCorrectingId
        artiRewriteId.value = item.artiRewriteId
        artiPolishingId.value = item.artiPolishingId
        item.artiCorrectingId && getCorrectingInfo((res) => {
            teachingActive.value = 'artiCorrecting'
            aiMessage.value = res.data.artiCorrectingResult;
        })
        item.artiRewriteId && getRewriteInfo()
        item.artiPolishingId && getPolishingInfo()
    }


}
function getCorrectingInfo(cb) {
    getCorrecting(artiCorrectingId.value).then((res: any) => {
        artiCorrectingInfo.value = res.data;
        artiCorrectingResultInfo.value = res.data.artiCorrectingResult ? resultFormat(res.data
            .artiCorrectingResult) : {}
        cb && cb(res)
    })
}
function getRewriteInfo() {
    getRewrite(artiRewriteId.value).then((res: any) => {
        artiRewriteInfo.value = res.data;
        artiRewriteResultInfo.value = res.data.artiRewriteResult ? resultFormat(res.data
            .artiRewriteResult) : {}
    })
}
function getPolishingInfo(cb) {
    getPolishing(artiPolishingId.value).then((res: any) => {
        artiPolishingInfo.value = res.data;
        artiPolishingResultInfo.value = res.data.artiPulishingResult ? resultFormat(res.data
            .artiPulishingResult) : {}
        cb && cb(res)
    })
}
function resultFormat(content) {
    const matches = content.match(regex) || [];
    let resultArr = matches.filter(match => match !== '');
    let resultNum = {},
        result = {},
        currentKey = '';
    resultArr.forEach(info => {
        if (romanNumeralsArr.includes(info)) {
            if (info in resultNum) {
                resultNum[info] = resultNum[info] + 1;
                result[info].push('');
            } else {
                resultNum[info] = 1;
                result[info] = [''];
            }
            currentKey = info;
        } else if (currentKey in result) {
            if (resultNum[currentKey] == 1) {
                result[currentKey][resultNum[currentKey] - 1] += info.replace(/^\s+/,
                    "").replace(/\n+/g, '<br/>');

            } else {
                result[currentKey][resultNum[currentKey] - 1] += info.replace(/\n+/g, '<br/>');
            }

        }
    })
    return result
}
function teachingClick(val) {
    switch (val) {
        case 'artiCorrecting':
            aiMessage.value = artiCorrectingInfo.value.artiCorrectingResult;
            break;
        case 'artiRewrite':
            aiMessage.value = artiRewriteInfo.value.artiRewriteResult;
            break;
        case 'artiPolishing':
            aiMessage.value = artiPolishingInfo.value.artiPulishingResult;
            break;
        default:
            return val
    }
}

function toPolish(item) {
    router.push({
        path: '/composition/polish',
        query: {
            artiRewriteId: item.artiRewriteId,
            artiCorrectingId: item.artiCorrectingId,
            page: 'history'
        }
    })
}
function toRewrite(item) {
    router.push({
        path: '/composition/rewrite',
        query: {
            artiCorrectingId: item.artiCorrectingId,
            page: 'history'
        }
    })
}
function delEvent() {
    console.log(tableList.value)
    let arr = tableList.value.filter(item => {
        return item.checked
    })
    if (!arr.length) {
        return ElMessage.warning('请选择记录！');
    } else {
        delArti(arr.map(item => {
            return item.artiCorrectingId
        })).then(res => {
            ElMessage.success('删除成功！');
            handleCurrentChange(1)
        })
    }
}

function cancelEvent() {
    isDelFlag.value = false;
    tableList.value.map(item => {
        item.checked = false
    })
}

onMounted(() => {
    getList(() => {
        toCorrectResult(tableList.value[0], 'correctResult')
    })
})
</script>

<style lang="scss" scoped>
@import "@/style/variable.scss";
.page-container {
    .page-left {
        background: rgba(255, 255, 255, 0.4)
    }
}

.paper-tabs {
    padding: 10px 0;
    text-align: center;
    width: 100%;
    font-size: 16px;
    font-weight: bold;
}

::v-deep .el-dropdown,
::v-deep .el-dropdown-link {
    outline: none;
}

.history-tab {
    margin: 20px 0;
    display: flex;
    justify-content: space-between;
    .history-tab-item {
        width: 100%;
        height: 40px;
        line-height: 40px;
        background: #fff;
        border-radius: 10px;
        text-align: center;
        cursor: pointer;
        &.active {
            background: $base-color;
            color: #fff;
        }
    }
    .history-tab-item+.history-tab-item {
        margin-left: 20px;
    }
}

.history-box {
    height: calc(100% - 181px);
    overflow-y: auto;
    .history-box-item {
        padding: 20px 15px;
        background: #fff;
        border-radius: 10px;
        .history-box-item-top {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid $base-border-color;
            padding: 0 15px 10px;
            align-items: center;
            .title1 {
                display: flex;
                align-items: center;
            }
        }
        .history-box-item-tag {
            display: flex;
            &>div {
                padding: 3px 8px;
                color: #fff;
                border-radius: 6px;
                font-size: 12px;
            }
            &>div+div {
                margin-left: 8px;
            }
            .tag1 {
                background: #00a4d7;
            }
            .tag2 {
                background: $base-color;
            }
            .correctClass02 {
                background: #7c84e9;
            }
            .correctClass03 {
                background: #e13d18;
            }
            .statusClass03 {
                background: #84c31a;
            }
        }
        .history-box-item-inner {
            margin: 10px 15px;
            font-size: 14px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 24px;
        }
        .history-box-item-bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 15px 0;
            .history-box-item-time {
                color: #999;
                font-size: 14px;
            }
        }
    }
    .history-box-item+.history-box-item {
        margin-top: 15px;
    }
}

.teaching-box-title {
    text-align: center;
    line-height: 28px;
    margin-bottom: 10px;
}

.teaching-box {
    border-bottom: 1px solid $base-border-color;
}

.history-file {
    display: flex;
    flex-wrap: wrap;
    margin: 10px 0;
    .history-file-item {
        border: 1px solid $base-border-color;
        width: 120px;
        height: 120px;
        border-radius: 10px;
        overflow: hidden;
        margin-right: 10px;
        margin-bottom: 10px;
    }
}

.history-tip {
    font-size: 12px;
    margin: 10px 0;
    color: #999;
}
</style>
